import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import api from "@/api/api.js";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "@/utils/stringUtils.js";

const CertificateUpload = ({ onUploadSuccess }) => {
  const { t } = useTranslation();
  const onDrop = useCallback(
    async (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;

      const file = acceptedFiles[0]; // Se asume subir un solo archivo
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await api.post(`/contacts/certificateTax`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.status === 200 || response.status === 201) {
          onUploadSuccess(response.data);
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: capitalizeFirstLetter(t("check the file")),
          text: err.response.data.error,
        });
      }
    },
    [onUploadSuccess],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      {...getRootProps()}
      className="dropzone mb-3"
      style={{
        border: "2px dashed #ccc",
        padding: "20px",
        textAlign: "center",
        cursor: "pointer",
      }}
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>Suelta el archivo aquí...</p>
      ) : (
        <p>Sube una nueva constancia de situación fiscal.</p>
      )}
    </div>
  );
};

export default CertificateUpload;
